import { render, staticRenderFns } from "./STPayment.vue?vue&type=template&id=3dc5197e&scoped=true&"
import script from "./STPayment.vue?vue&type=script&lang=js&"
export * from "./STPayment.vue?vue&type=script&lang=js&"
import style0 from "./STPayment.vue?vue&type=style&index=0&id=3dc5197e&lang=less&scoped=true&"
import style1 from "./STPayment.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5197e",
  null
  
)

export default component.exports